// Petit store externe pour signaler au frontend qu'une recherche a été « relâchée »
// (aucun résultat exact → fuzzy réactivé en repli). Permet à FuzzyNotice de réagir
// sans dépendre du passage de propriétés custom à travers SearchKit/InstantSearch.

let value = false;
const listeners = new Set();

export function setFuzzyFallback(next) {
  const v = !!next;
  if (value === v) return;
  value = v;
  listeners.forEach((l) => l());
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getFuzzyFallback() {
  return value;
}
